import { useState } from 'react';
import css from './index.module.scss';
import EFPicture from 'elem/compCommon/EFPicture';

export default function CastCardPopUp({ callback }: any) {
    const [cartKey, setCartKey] = useState('2');
    const dataB = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747031400170/Bundle_1.png',
            title: 'DELTA Pro Ultra + Smart Home Panel 2 (6kWh)',
            number: '$3,000',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747031399986/Bundle_1%20(1).png',
            title: 'DELTA Pro Ultra + Smart Home Panel 2 + Extra Battery (12kWh)',
            number: '$5,000 (max)',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747031400488/Bundle_1%20(2).png',
            title: 'DELTA Pro Ultra + Smart Home Panel 2 + 2 Extra Battery (18kWh)',
            number: '$5,000 (max)',
        },
    ];
    const dataA = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747031400170/Bundle_1.png',
            title: 'DELTA Pro Ultra + Smart Home Panel 2 (6kWh)',
            number: '$1,800',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747031399986/Bundle_1%20(1).png',
            title: 'DELTA Pro Ultra + Smart Home Panel 2 + Extra Battery (12kWh)',
            number: '$3,600',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1747031400488/Bundle_1%20(2).png',
            title: 'DELTA Pro Ultra + Smart Home Panel 2 + 2 Extra Battery (18kWh)',
            number: '$5,000 (max)',
        },
    ];
    return (
        <div className={`castCard-popup ${css['castCard-popup']}`}>
            <div className="castCard-popup-content">
                <header className="castCard-popup-header">
                    <span>Calculate the rebates</span>
                    <svg
                        className="header-close"
                        onClick={() => callback(false)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </header>
                <body className="castCard-popup-body">
                    <p className="castCard-cart">
                        <p className={`castCard-cart${cartKey === '1' ? '-active1' : '-brn1'}`} onClick={() => setCartKey('1')}>
                            Ontario's Home Renovation Savings Program
                        </p>
                        <p className={`castCard-cart${cartKey === '2' ? '-active2' : '-brn2'}`} onClick={() => setCartKey('2')}>
                            BC Hydro rebates
                        </p>
                    </p>
                    <p className="castCard-desc">
                        {cartKey === '2'
                            ? 'Receive a $500 rebate per kWh of installed storage capacity, up to a maximum of $5,000 CAD'
                            : 'Receive a $300 rebate per kWh, up to a maximum of $5,000 CAD'}
                    </p>
                    {/* <p className="castCard-text">{"You'll get the following exclusive services:"}</p> */}
                    <ul className="lists">
                        {(cartKey === '1' ? dataA : dataB)?.map((list: any, k: number) => (
                            <li className="list" key={k}>
                                <div className="list-left-item">
                                    <p className="list-img">
                                        <EFPicture src={list.img} alt={list.title}></EFPicture>
                                    </p>
                                    <span className="list-title">{list.title}</span>
                                </div>
                                <span className="list-number">{list.number}</span>
                            </li>
                        ))}
                    </ul>
                </body>
            </div>
        </div>
    );
}
